import React, { useState } from "react";
import controls, { restoreCallAfterBackground } from "./controls";
// import useAudioStore from "../store/useAudioStore";


const AudioPlayer = () => {
  // const audioRef = useRef(null);
  const [audio, setThisAudio] = useState("")
  // const { isPlaying } = useAudioStore();

  controls.setAudio = setThisAudio;
  controls.requestAudioUnlock = async () => {
    if (controls.callAnswered && controls.room) {
      return restoreCallAfterBackground();
    }
    const player = document.getElementById("myPlayer");
    if (!player) return false;
    try {
      await player.play();
      controls.audioBlocked = false;
      return true;
    } catch (_) {
      controls.audioBlocked = true;
      return false;
    }
  };
  console.log("AUDIO PLAYER", audio);

  return (
    <div key={audio}>
      <audio controls webkit-playsinline="true" playsInline={true}
      onLoadedData={()=>{
        const p = document.getElementById("myPlayer").play();
        if (p && typeof p.catch === "function") {
          p.then(() => {
            controls.audioBlocked = false;
          }).catch(() => {
            controls.audioBlocked = true;
          });
        } else {
          controls.audioBlocked = false;
        }
      }}
      onPlay={() => {
        controls.audioBlocked = false;
      }}
      // muted={isPlaying} 
      id="myPlayer">
        <source src={audio} type="audio/mp3"  />
      </audio>
    </div>
  );
};

export default AudioPlayer;
